import React, { useState } from "react";
import moment from "moment";

import FootprintDatePicker from "../../../Components/utils/FootprintDatePicker";
import { SERVER_DATE_FORMAT } from "./TakeABreak";
import { useLocation, useNavigate } from "react-router-dom";
import { useRequestProcessor } from "../../../requestProcessor";
import { resumeFromBreak } from "../../../QueryFunctions/queryfunction";

import SpinnerLoading from "../../../Components/utils/SpinnerLoading";
import { StyledButton, StyledCardHeader } from "./styles";
import { mobileAtom } from "../../../AtomStore/store";
import { useAtom } from "jotai";
export const DEFAULT_FORMAT = "MMM DD, YYYY";

const EarlyResume = () => {
  const location = useLocation();

  const item = location.state;
  const [state, setState] = useState({ endDate: "" });
  const { useMutationWrapper } = useRequestProcessor();

  const navigate = useNavigate();

  const Resume = useMutationWrapper("Resume", () =>
    resumeFromBreak(item.request_id, state.endDate, navigate)
  );
  const validate = () => {
    if (state.endDate === undefined) {
      setState({ ...state, error: "Please Select End Date" });
      return false;
    } else {
      return true;
    }
  };

  const submit = (e) => {
    e.preventDefault();
    if (validate()) {
      Resume.mutate();
    } else {
    }
  };
  if (item) {
    return (
      <div className="m-[10px] mt-[20px]">
        {Resume?.isLoading && <SpinnerLoading />}

        <div className="bg-white rounded-lg shadow-md p-2">
          <form className="md:p-4 space-y-4 pb-4 ">
            <div className="grid grid-cols-2">
              {/* Current End Time */}
              <div className="border-r mr-2">
                <label className="block text-sm font-medium text-black mb-2">
                  Current End Time
                </label>
                <div className="flex items-center">
                  {/* <i className="icon-calender text-2xl text-black mr-2" /> */}
                  <FootprintDatePicker
                    defaultDate={moment(item?.end_date).format(DEFAULT_FORMAT)}
                    inputProps={{ disabled: true }}
                    disabled={true}
                  />
                </div>
              </div>

              {/* New Date */}
              <div>
                <label className="block text-sm font-medium text-black mb-2">
                  New Date
                </label>
                <div className="flex items-center right-align">
                  {/* <i className="icon-calender text-2xl text-black mr-2" /> */}
                  <FootprintDatePicker
                    minimumDate={moment(item?.date, SERVER_DATE_FORMAT).add(
                      1,
                      "days"
                    )}
                    maximumDate={moment(
                      item?.end_date,
                      SERVER_DATE_FORMAT
                    ).subtract(1, "days")}
                    onChange={(date) => {
                      setState({
                        ...state,
                        holidaySelected: false,
                        endDate: date,
                        error: undefined,
                      });
                    }}
                    inputProps={{
                      placeholder: "Select date",
                    }}
                    timeFormat={false}
                  />
                </div>
              </div>
            </div>

            {/* Error Message */}
            {state.error && (
              <div className="text-red-500 text-sm">{state?.error}</div>
            )}

            {/* Submit Button */}
            <div className="text-center">
              <StyledButton
                className="bg-header text-white px-6 py-2 rounded-md"
                onClick={(e) => submit(e)}
              >
                Submit
              </StyledButton>
            </div>
          </form>
        </div>
      </div>
    );
  } else {
    return <div>Early Resume</div>;
  }
};

export default EarlyResume;
